import _ from 'lodash';
import { DateTime } from 'luxon';
import { INPUT_DATE } from './formats';

export const fromDatetimeInputToISO = (
    startDate: string,
    startHour: string,
) => {
    if (!_.isString(startDate) && !_.isString(startHour)) {
        return '-';
    }
    if (_.isString(startDate) && !_.isString(startHour)) {
        return DateTime.fromFormat(startDate, INPUT_DATE).toISODate() as string;
    }
    return (
        DateTime.fromFormat(startDate, INPUT_DATE).toISODate() +
        'T' +
        _.padStart(
            (startHour === 'Mediodía' ? '12:00' : startHour) as string,
            5,
            '0',
        ) +
        ':00'
    );
};
